module.exports = __webpack_public_path__ + "img/icon_email.662aad0e.png";